import React from "react"
import {Icon, NameIcon} from "../../../ui/Icon/Icon"
import {ReactComponent as AlertsIcon} from "../../../graphics/notificationsIcons/alerts.svg"
import {ReactComponent as DisconnectIcon} from "../../../graphics/notificationsIcons/Disconnect.svg"
import {ReactComponent as OffScheduledIcon} from "../../../graphics/notificationsIcons/OffScheduled.svg"
import {Portal} from "../../../types/securityTypes"
import {ReactComponent as InfoIcon} from "./info.svg"

const customNotificationsIcons: Partial<Record<string, React.FC<React.SVGProps<SVGSVGElement>>>> = {
    ALERTS: AlertsIcon,
    DISCONNECT: DisconnectIcon,
    OFFSCHEDULED: OffScheduledIcon,
}

export const NotificationIcon: React.FC<{
    messageType: string | Portal
    isEvent?: boolean
    className?: string
}> = ({messageType, isEvent, className}) => {
    const CustomIcon = customNotificationsIcons[messageType]

    if (CustomIcon) return <CustomIcon className={className} />

    if (isEvent) return <InfoIcon className={className} />

    return <Icon name={messageType as NameIcon} className={className} />
}
